import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { OtherUseCreateWithLocationDto } from '../dtos/other-use/models';
import type { GetOtherUsesByNamesInputDto, GetOtherUsesInputDto, OtherUseDto } from '../../planning/dtos/other-use/models';

@Injectable({
  providedIn: 'root',
})
export class OtherUseOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  createWithLocation = (input: OtherUseCreateWithLocationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto>({
      method: 'POST',
      url: '/api/orchestrator/other-use-orchestrator/with-location',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  findByNames = (input: GetOtherUsesByNamesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OtherUseDto[]>({
      method: 'POST',
      url: '/api/orchestrator/other-use-orchestrator/find-by-names',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOtherUsesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OtherUseDto>>({
      method: 'GET',
      url: '/api/orchestrator/other-use-orchestrator',
      params: { name: input.name, otherUsearea: input.otherUsearea, otherUseareaFrom: input.otherUseareaFrom, otherUseareaTo: input.otherUseareaTo, soilUseId: input.soilUseId, soilUseName: input.soilUseName, locationId: input.locationId, locationName: input.locationName, propertyTypeId: input.propertyTypeId, propertyTypeName: input.propertyTypeName, propertyId: input.propertyId, propertyName: input.propertyName, isFOManagement: input.isFOManagement, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
}